import type { ProjectConfig } from "@/types/project-config";

export const PROJECT_CONFIG: ProjectConfig = {
  name: "Offer Optimist",
  shortDescription: "Credit Card Sign Up Bonus Comparison Engine",
  longDescription:
    "Offer Optimist is a powerful credit card sign up bonus filtering and comparison tool. We avoid affiliate marketing in order to remain unbiased, so if you want to support the site, use a referral link when listed or share the site with friends!",
  domain: "offeroptimist.com",
  subreddit: "https://reddit.com/r/offeroptimist",
};
